{
  "checkedInTitle": "Seu check-in foi realizado",
  "postCheckInInstructions": "Instruções pós check-in",
  "appointmentDetails": "Detalhes do agendamento",
  "notifyWarehouse": "Avisamos ao armazém que você chegou para que possam verificar a disponibilidade",
  "waitForStaff": "Por favor, aguarde instruções adicionais da equipe do armazém",
  "unplannedDescription": "Parece que você não tem um agendamento. Por favor, aguarde instruções adicionais da equipe do armazém.",
  "whatsappDelay": "A primeira mensagem pelo WhatsApp pode levar até um minuto para chegar.",
  "bookNextTitle": "Agende um horário para a próxima vez",
  "bookNextBody": "Cadastre-se no Opendock para agendar um horário na próxima vez que visitar esta unidade",
  "helpFooter": "Se precisar de ajuda ou informações adicionais, entre em contato com a equipe do armazém",
  "finalize": "Finalizar ({seconds})"
}
